import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { H1, TextSmall, TextXSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import calendarPng from '/img/dice-game/calendar.png';
import calendarWebp from '/img/dice-game/calendar.webp';
import containerPng from '/img/dice-game/container.png';
import containerWebp from '/img/dice-game/container.webp';

const PhaseInfo: FC = () => {
  const { t } = useTranslation();

  const descriptionMockData = [
    {
      image: {
        png: containerPng,
        webp: containerWebp,
        className: 'aspect-[172/162] w-[134.375%] -translate-y-1/2',
      },
      text: 'Complete contracts and open containers for a chance to get dice. The more you play, the more rolls you earn.',
    },
    {
      image: {
        png: calendarPng,
        webp: calendarWebp,
        className: 'aspect-[144/160] w-[112.5%] -translate-y-[40%]',
      },
      text: 'Watch out for tasks — many reward you with dice. Complete goals, hit targets, and stack up rolls for your next game.',
    },
  ];

  return (
    <div className={css.phaseInfo}>
      <H1 weight="black" className="!text-gold mb-3">
        {t('Accumulation Phase')}
      </H1>
      <TextXSmall className="!text-white/60 !text-[12px] !leading-1.3 max-w-[16.875rem] text-center mb-8">
        {t(
          'While Roll Craft is on pause, stock up on dice through containers and tasks',
        )}
      </TextXSmall>
      <div className="w-full flex flex-col gap-8">
        {descriptionMockData.map(({ image, text }, index) => (
          <div key={index} className="flex items-center gap-4">
            <div className="w-16 h-16 relative shrink-0">
              <Picture
                className={cn(
                  'absolute top-1/2 left-1/2 -translate-x-1/2 ',
                  image.className,
                )}
                img={image.png}
                webp={image.webp}
                alt="alt"
              />
            </div>
            <TextSmall
              weight="regular"
              className="!text-white/80 !leading-1.3 !text-[14px]"
            >
              {t(text)}
            </TextSmall>
          </div>
        ))}
      </div>
    </div>
  );
};

export { PhaseInfo };
